import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {ItemNumber} from "../../components/ViewData";
import {CapitalSriInterface} from "../../../services/interface/sri/capital-sri-interface";
import {useTaxPayerStorage} from "../../../services/storage/TaxPayerStorage";
import {useFindCapital} from "../../../services/apis/apiRuc";
import NotPermissionComponent from "../../dashboard/NotPermissionComponent";
import NoRecords from "../../components/NoRecords";

interface Props {

}
export default function Capital({}: Props) {
    const { t } = useTranslation("global") as { t: (key: string) => string };
    const [info, setInfo] =
        useState<CapitalSriInterface | undefined>();

    const person = useTaxPayerStorage(data => data.data)

    const {
        mutate: findCapital,
        data: successCapital,
        error: errorCapital,
        isPending: loadingCapital,
    } = useFindCapital()

    useEffect(() => {
        if (person?.accountant || person?.taxIdentificationNumber) {
            findCapital({
                identifier: person?.accountant ? person?.accountant : person?.taxIdentificationNumber,
                msj: t('capital-to-date')
            })
        }
    }, [person]);

    useEffect(() => {
        if (successCapital) {
            setInfo(successCapital)
        }
    }, [successCapital]);

    return(
        <>
            <h3>{t('capital-to-date')}</h3>
            <div className={'mt-1 custom-card py-3 px-3 flex flex-col gap-2 '}>
                <NotPermissionComponent
                    className={'min-h-[50px]'}
                    title={'/pj_information/capital'}
                    loading={loadingCapital}
                    error={errorCapital}
                    component={info ?
                        <>
                            <div
                                className={'grid grid-cols-1 md:grid-cols-3 gap-2'}>
                                <ItemNumber label={t('subscribed-capital')} value={`$${info?.subscribedCapital ?? '-'}`}/>
                                <ItemNumber label={`${t('authorized-capital')}`} value={`$${info?.authorizedCapital ?? '-'}`}/>
                                <ItemNumber label={`${t('par-value-shares')}`} value={`$${info?.nominalValueShares ?? '-'}`}/>
                            </div>
                        </> : <NoRecords/>
                    }
                />
            </div>
        </>
    )
}
